<template>
  <div class="container">
    <!-- 支付结果内容 -->
    <div class="content">
      <div class="img-wrap">
        <img :src="images.paySuccess" alt="">
      </div>
      <div class="result-text">支付成功</div>
      <div class="tip">
        小麦助教期待和校区一起进入信息化管理新元年，助力管理升级！
      </div>
    </div>
    <!-- 完成支付 -->
    <div class="footer">
      <div class="btn-pay">完成支付</div>
    </div>
  </div>
</template>
<script>
import paySuccess from '@/images/renew/pay-success.png';

export default {
  data() {
    return {
      images: {
        paySuccess
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  .content {
    padding: 0.92rem 0rem 0.4rem;
    background-color: #fff;
    .img-wrap {
      line-height: 0;
      img {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
    .result-text {
      margin-top: 0.3rem;
      font-size: 0.34rem;
    }
    .tip {
      margin-top: 0.14rem;
      padding: 0 1.36rem;
      font-size: 0.26rem;
      color: #999999;
    }
  }
  .footer{
    margin-top: 0.8rem;
    padding: 0 0.32rem;
    .btn-pay{
      padding: 0.24rem;
      border-radius: 0.1rem;
      color: #fff;
      font-size: 0.3rem;
      background: -webkit-linear-gradient(left, #FFAB1A , #ff8534); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(right, #FFAB1A, #ff8534); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(right, #FFAB1A, #ff8534); /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #FFAB1A , #ff8534); /* 标准的语法 */
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/module/renew/payResult.vue